module.exports = __webpack_public_path__ + "img/yiyan.4447ad53.jpg";